import { render, staticRenderFns } from "./DetailRight.vue?vue&type=template&id=09c3dec8&scoped=true&"
import script from "./DetailRight.vue?vue&type=script&lang=js&"
export * from "./DetailRight.vue?vue&type=script&lang=js&"
import style0 from "./DetailRight.vue?vue&type=style&index=0&id=09c3dec8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3dec8",
  null
  
)

export default component.exports